"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCart = exports.postFormData = void 0;
var react_query_1 = require("@tanstack/react-query");
function postFormData(url, data) {
    return __awaiter(this, void 0, void 0, function () {
        var body, response, text;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = new FormData();
                    Object.entries(data).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        if (Array.isArray(value)) {
                            value.forEach(function (v) { return body.append(key + "[]", v); });
                        }
                        else {
                            body.append(key, value);
                        }
                    });
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            body: body,
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.text()];
                case 2:
                    text = _a.sent();
                    try {
                        return [2 /*return*/, JSON.parse(text)];
                    }
                    catch (e) {
                        return [2 /*return*/, text];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.postFormData = postFormData;
function useCart() {
    var _this = this;
    var _a, _b, _c;
    var query = (0, react_query_1.useQuery)({
        queryKey: ["cart"],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, postFormData("/shop_handler.php", {
                        task: "updateCart",
                    })];
            });
        }); },
        initialData: null,
    });
    var deleteMutation = (0, react_query_1.useMutation)({
        mutationFn: function (training) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (training.type === "training") {
                    return [2 /*return*/, postFormData("/shop_handler.php", {
                            task: "deleteFromCart",
                            trainingID: training.ID,
                        })];
                }
                else if (training.type === "lighttraining") {
                    return [2 /*return*/, postFormData("/shop_handler.php", {
                            task: "deleteFromCartLight",
                            trainingID: training.ID,
                        })];
                }
                return [2 /*return*/];
            });
        }); },
        onSuccess: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                query.refetch();
                return [2 /*return*/];
            });
        }); },
    });
    var cart = (_a = query.data) === null || _a === void 0 ? void 0 : _a.shopcartData;
    var count = ((_b = cart === null || cart === void 0 ? void 0 : cart.trainingen.length) !== null && _b !== void 0 ? _b : 0) + ((_c = cart === null || cart === void 0 ? void 0 : cart.ltrainingen.length) !== null && _c !== void 0 ? _c : 0);
    return {
        cart: cart,
        count: count,
        deleteTraining: deleteMutation.mutate,
    };
}
exports.useCart = useCart;
